import { useForm } from "react-hook-form";
import useCreate from "../../useCreate";
import toast from "react-hot-toast";
import useRead from "../../useRead";

const useCashOnDeliverySettings = () => {
  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      is_cod_allowed: false,
      cod_value: null,
    },
  });

  const { data: settingsReq } = useRead({
    url: "fetch_company_settings",
    method: "GET",
    onSuccess: (data) => {
      const resData = data?.data || {};
      setValue("is_cod_allowed", resData?.is_cod_allowed || false);
      setValue("cod_value", resData?.cod_value || null);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Error fetching settings");
    },
  });
  const areSettingsLoading = settingsReq?.isLoading;

  const { setDataToServer: saveRequest } = useCreate({
    url: "add_company_settings",
    onSuccess: () => {
      toast.success("Settings saved successfully");
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "An error occurred");
    },
  });
  const isSaving = saveRequest.isLoading;

  const onSubmit = (data) => {
    saveRequest.mutate(data);
  };

  return { onSubmit, register, handleSubmit, isSaving, areSettingsLoading };
};

export default useCashOnDeliverySettings;
